module.exports = "/_next/static/images/google-play-badge-5467babe5628d6adc9ab83d2def58631.svg";